import Autolinker from 'autolinker';
export const autolink = (description: string) => {
  return Autolinker.link(description, {
    stripPrefix: false,
    stripTrailingSlash: false,
  });
};
